module.exports = __webpack_public_path__ + "img/ic-rp.99f7de8f.svg";